import { defineMessages } from 'react-intl';

export default defineMessages({
  asset: 'Asset',
  search: 'Search',
  noDataTitle: 'There are no asset matching the parameters',
  APY: 'APY',
});
